import { parseTime } from '@/utils/common'
const statusConversionList = {
  normalStatus: [
    { label: '正常', value: 0 },
    { label: '停用', value: 1 }
  ],
  //采摘要求
  readyForHarvestStatus: [
    { label: '达标', value: 1 },
    { label: '不达标', value: 2 },
    { label: '其他', value: 0 }
  ],
  readyForHarvestStatus1: [
    { label: '达标', value: 1 },
    { label: '不达标', value: 2 },
  ],
  //农残
  pesticideTestPassedStatus: [
    { label: '合格', value: 1 },
    { label: '不合格', value: 2 },
    { label: '其他', value: 0 },
  ],
  pesticideTestPassedStatus1: [
    { label: '合格', value: 1 },
    { label: '不合格', value: 2 },
  ],
  //农残检测农残使用
  pesticideTestPassedStatus2: [
    { label: '合格', value: 1 },
    { label: '不合格', value: 0 },
  ],
  //重金属
  heavyMetalTestPassedStatus: [
    { label: '合格', value: 1 },
    { label: '不合格', value: 2 },
    { label: '其他', value: 0 }
  ],
  heavyMetalTestPassedStatus1: [
    { label: '合格', value: 1 },
    { label: '不合格', value: 2 },
  ],
  //农残检测重金属使用
  heavyMetalTestPassedStatus2: [
    { label: '合格', value: 1 },
    { label: '不合格', value: 0 },
  ],
  //走访任务
  taskStatus: [
    { label: '未走访', value: 0, color: 'info'},
    { label: '进行中', value: 1, color: 'warning' },
    { label: '已走访', value: 2, color: 'success' },
    { label: '已取消', value: 3, color: 'danger' }
  ],
  taskStatus1: [
    { label: '未走访', value: 0},
    { label: '已走访', value: 2},
  ],
  //采摘状态
  pickStatus: [
    { label: '未派发', value: 1, color: 'info' },
    { label: '未巡查', value: 2, color: 'warning' },
    { label: '巡查中', value: 3, color: 'warning' },
    { label: '采摘中', value: 4, color: 'warning' },
    { label: '已采摘', value: 5, color: 'success' },
    { label: '已取消', value: 6, color: 'danger' },
  ],
  //溯源步骤
  traceabilityStep: {
    picking_batch_task: { text: '采摘', bgColor: '#47b700', mapKey: 'pickMap', },
    shipping_order_item: { text: '运输', bgColor: '#4486b3', mapKey: 'shippMap', },
    inspection_sheet_item: { text: '鲜果验收', bgColor: '#cb921b', mapKey: 'inpectionMap', },
    fresh_peel_prod_rec: { text: '生产加工', bgColor: '#4486b3', mapKey: 'freshMap', },
    dry_peel_prod_rec : { text: '干皮记录', bgColor: '#cb921b', mapKey: 'dryMap', },
  },
  //干皮验收状态
  dryCheckStatus: [
    { label: '未验收', value: 0, color: 'info' },
    { label: '已验收', value: 1, color: 'success' },
    // { label: '入库完成', value: 2 },
  ],
  //仓库状态
  warehouseStatus: [
    { label: '待入库', value: 1, color: 'info' },
    { label: '入库完成', value: 2, color: 'success' },
  ],
}
export default {
  ...statusConversionList,
  getStatusConversion(status, type) {
    let s = statusConversionList[type].find((t) => t.value == status)
    let text = s ? s.label : ''
    return text != '其他' ? text : ''
  },
  getStatusConversionColor(status, type) {
    let s = statusConversionList[type].find((t) => t.value == status)
    return s.color
  },
  getStatusConversionForYear(status, type, date) {
    const year = parseTime(date, '{y}', [2, 4])
    let s = statusConversionList[type].find((t) => t.value == status)
    let text = s ? s.label : ''
    return text != '其他' ? `${text}(${year}年)` : ''
  },
}
